<template>
    <q-page class="q-pa-md" style="height: 100%; overflow-y: auto;">
        <!-- GRID DE CARDS -->
        <div class="row doc-note">
            <div class=" row full-width doc-note__title">Importante*</div>
            <p class="row text-body1">Los valores que se muestran es de acuerdo a la información que corresponde al mes
                corriente. </p>
            <p><b>(Cuentas por Pagar, Cuentas por Cobrar, Seguros por Vencer).</b></p>

        </div>

        <div class="row q-col-gutter-md">
            <metric-card title="Clientes" :value="metrics.clientes" icon="people" color="color-2" />
            <metric-card title="Autos" :value="metrics.autos" icon="directions_car" color="color-2" />
            <metric-card title="Solicitudes nuevas" :value="metrics.solicitudes" icon="assignment" color="color-2" />
            <metric-card title="Cotizaciones aceptadas" :value="metrics.cotizaciones" icon="request_quote"
                color="color-2" />
            <metric-card title="Contratos" :value="metrics.contratosVigentes" icon="description" color="color-3" />
            <metric-card title="Seguros por vencer*" :value="metrics.segurosPorVencer" icon="verified_user"
                color="color-3" />
            <metric-card title="Cuentas por cobrar*" :value="metrics.cuentasPorCobrar" icon="attach_money"
                color="color-2" />
            <metric-card title="Cuentas por pagar*" :value="metrics.cuentasPorPagar" icon="credit_card"
                color="color-2" />
        </div>


        <!-- GRÁFICAS -->
        <div class="row q-col-gutter-lg  q-mt-sm">
            <!-- Autos por estatus -->
            <div class="col-12 col-md-4">
                <q-card>
                    <div class="text-h6 text-center q-pa-sm">Autos por Estatus</div>
                    <div ref="chartAutos" style="height:300px;"></div>
                </q-card>
            </div>

            <div class="col-12 col-md-4">
                <q-card>
                    <div class="text-h6 text-center q-pa-sm">Cuentas por Cobrar</div>
                    <div ref="chartC" style="height:300px;"></div>
                </q-card>
            </div>

            <div class="col-12 col-md-4">
                <q-card>
                    <div class="text-h6 text-center q-pa-sm">Cuentas por Pagar</div>
                    <div ref="chartP" style="height:300px;"></div>
                </q-card>
            </div>

            <!-- Ingresos vs Egresos -->
            <!-- <div class="col-12 col-md-6">
                <q-card>
                    <div class="text-h6 text-center q-pa-sm">Ingresos vs Egresos</div>
                    <div ref="chartFinanzas" style="height:300px;"></div>
                </q-card>
            </div> -->

            <!-- Contratos por mes -->
            <!-- <div class="col-12">
                <q-card class="q-pa-md q-mt-md">
                    <div class="text-h6 q-mb-md">Contratos firmados por mes</div>
                    <div ref="chartContratos" style="height:400px;"></div>
                </q-card>
            </div> -->

        </div>
    </q-page>
</template>

<script>
import * as echarts from "echarts";
import MetricCard from "./MetricCard.vue";
import { QSpinnerClock } from 'quasar'
import axios from "axios";
import { generarSeguroPDF } from "../../PDF/SegurosPDF";

export default {
    name: "Dashboard",
    components: {
        MetricCard
    },
    data() {
        return {
            metrics: {
                clientes: 0,
                autos: 0,
                solicitudes: 0,
                cotizaciones: 0,
                contratosVigentes: 0,
                contratosPorVencer: 0,
                segurosPorVencer: 0,
                autosMantenimiento: 0,
                proveedores: 0,
                facturas: 0,
                cuentasPorCobrar: 0,
                cuentasPorPagar: 0
            },
            autosEstatus: [],
            CXC: [],
            CXP: [],
            pdfBaseSeguros:'',
            listaSeguros:[]
        };
    },
   
    created() {
        this.GetReportes()
    },
    methods: {
        async VerSeguros() {
            try {
                let base64 = ''
                const logoURL = require('./../../../assets/logo_top.png')
                this.logoBase64 = await this.cargarImagenComoBase64(logoURL);
                base64 = await generarSeguroPDF( this.listaSeguros, this.logoBase64 );
                this.pdfBaseSeguros =  base64.split(',')[1];
            } catch (error) {
                console.log(error)
            }
        },
        cargarImagenComoBase64(url) {
            return new Promise((resolve, reject) => {
                const img = new Image()
                img.crossOrigin = 'Anonymous'
                img.onload = function () {
                    const canvas = document.createElement('canvas')
                    canvas.width = this.width
                    canvas.height = this.height
                    const ctx = canvas.getContext('2d')
                    ctx.drawImage(this, 0, 0)
                    const dataURL = canvas.toDataURL('image/png')
                    resolve(dataURL)
                }
                img.onerror = reject
                img.src = url
            })
        },
        async GetReportes() {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Generando reporte. Espere...', messageColor: 'white' })
            try {
                let respuesta = await axios.get('Reportes/GetReporteTotalesAsync')
                console.log(respuesta)

                this.metrics.autos = respuesta.data.autos
                this.metrics.clientes = respuesta.data.clientes
                this.metrics.solicitudes = respuesta.data.solicitudes
                this.metrics.cotizaciones = respuesta.data.cotizaciones
                this.metrics.contratosVigentes = respuesta.data.contratos
                this.metrics.segurosPorVencer = respuesta.data.seguros
                this.metrics.cuentasPorCobrar = this.formatoMonedaMexicana(respuesta.data.cuentasCobrar[0].value)
                this.metrics.cuentasPorPagar = this.formatoMonedaMexicana(respuesta.data.cuentasPagar[0].value)
                this.autosEstatus = respuesta.data.autosEstatus
                this.CXC = respuesta.data.cuentasCobrarTodos
                this.CXP = respuesta.data.cuentasPagarTodos
                this.listaSeguros = respuesta.data.segurosDoc
                
                if( this.listaSeguros.length > 0){
                    await this.VerSeguros();
                    await this.notificarCuentaCobrar();
                }
                await this.initCharts();
                

                this.$q.loading.hide()
            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
            }
        },

        async notificarCuentaCobrar() {
            // console.log(this.selectCotizacion)
            // this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Enviando notificación por WhatsApp. Espere...', messageColor: 'white' })
            let objeto = {
                id_usuario: '68dc3cf47e55aa4302f0571e',
                mensaje: 'Se envia el documento seguros por vencer en el actual mes. Seguros por Vencer ('+ this.metrics.segurosPorVencer+')',
                base64:this.pdfBaseSeguros
            }
            try {
                let response = await axios.post('Notificaciones/Notificacion', objeto);
                console.log(response)
               
            } catch (error) {
                console.log(error)
            }
        },

        initCharts() {
            // Autos por estatus
            const chartAutos = echarts.init(this.$refs.chartAutos);
            chartAutos.setOption({
                tooltip: {},
                series: [
                    {
                        type: "pie",
                        data: this.autosEstatus
                    }
                ]
            });

            const chartC = echarts.init(this.$refs.chartC);
            chartC.setOption({
                tooltip: {},
                series: [
                    {
                        type: "pie",
                        data: this.CXC
                    }
                ]
            });

            const chartP = echarts.init(this.$refs.chartP);
            chartP.setOption({
                tooltip: {},
                series: [
                    {
                        type: "pie",
                        data: this.CXP
                    }
                ]
            });

            // Ingresos vs Egresos
            // const chartFinanzas = echarts.init(this.$refs.chartFinanzas);
            // chartFinanzas.setOption({
            //     tooltip: {},
            //     legend: { data: ["Ingresos", "Egresos"] },
            //     xAxis: { type: "category", data: ["Enero", "Feb", "Mar", "Abr", "May", "Jun"] },
            //     yAxis: { type: "value" },
            //     series: [
            //         {
            //             name: "Ingresos",
            //             type: "bar",
            //             data: [50000, 70000, 65000, 80000, 95000, 72000]
            //         },
            //         {
            //             name: "Egresos",
            //             type: "bar",
            //             data: [30000, 40000, 38000, 42000, 50000, 45000]
            //         }
            //     ]
            // });

            // // Contratos por mes
            // const chartContratos = echarts.init(this.$refs.chartContratos);
            // chartContratos.setOption({
            //     tooltip: { trigger: "axis" },
            //     xAxis: { type: "category", data: ["Ene", "Feb", "Mar", "Abr", "May", "Jun"] },
            //     yAxis: { type: "value" },
            //     series: [
            //         {
            //             type: "line",
            //             smooth: true,
            //             data: [5, 12, 9, 15, 20, 18],
            //             areaStyle: {}
            //         }
            //     ]
            // });
        },

        formatoMonedaMexicana(valor) {
            return valor.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
    }
};
</script>
<style>
.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>